<!--
 * @Author: 'qhy' '272921690@qq.com'
 * @Date: 2022-10-28 13:39:12
 * @LastEditors: 'qhy' '272921690@qq.com'
 * @LastEditTime: 2023-03-14 09:56:55
 * @FilePath: \edu_ytsr_show_total_vue\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <footer class="footer">
    <div class="container" style="margin-bottom:0">
      <!-- <h3 class="logo">唐山职业教育网络教学资源库</h3> -->
      <div class="divider-box">
        <a v-if="item.title!='名师讲堂'" @click="navClick(item, index)" v-for="(item,index) in navList.slice(0,9)" :key="index">{{ item.title }} <span
            class="line" v-if="index <= 7">|</span> </a>
      </div>
      <div class="icp" v-if="footerList">
        <span v-for="(item, index) in footerList.footer1.split('|')" :key="index">
         <a target="_blank" :href="item.split('$')[1]"> {{ item.split('$')[0] }}</a> 
        </span>
        <div class="icp2">
          <span v-for="(item, index) in footerList.footer2.split('|')" :key="index">
            <a :href="item.split('$')[1] "></a>  {{ item.split('$')[0]  }}
          </span>
        </div>
        <div class="icp2"> <a :href="footerList.beian.split('$')[1]" target="_blank">{{ footerList.beian.split('$')[0] }}</a> </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';
import mixin from '@/utils/mixin';
import { getWebFooter } from '@/utils/api'
export default {
  computed: mapGetters(['navList']),
  mixins: [mixin],
  data() {
    return {
      footerList: null
    }

  },
  mounted() {
    getWebFooter({
      organizeId: this.$config.organizeId
    }).then(res => {
      this.$store.commit('set_service',res.data.telePhone)
      this.footerList = res.data
    })
  }
}
</script>
<style scoped lang="scss">
.footer {
  height: 168px;
  background: #434343;
  user-select: none;
}

.container {
  text-align: center;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
}

.divider-box {
  margin: 10px 0;

  a {
    cursor: pointer;

    .line {
      padding: 0 8px;
    }
  }

}



.icp {
  margin-bottom: 10px;
  span{
    margin-right: 15px;
    a{
      color: #fff;
    }
  }
}

.icp2 {
  margin-top: 10px;
  a{
    color: #fff;
  }
}

.source {
  text-align: center;
}

.source span {
  margin: 0 15px;
}

.footer-bottom {
  width: 100%;
  background: #3390f8;
  height: 48px;
  overflow: hidden;
  color: #fff;
  line-height: 48px;
  font-size: 14px;
}
</style>